import styled, { css } from 'styled-components';
import { BlockBase } from '../../styles';

interface ColProps {
  columnWidth?: number;
}

interface CurrentIndicatorProps {
  top: number;
}

interface ColBlockProps {
  isHalf?: boolean;
  isExistSchedule?: boolean;
}

export const Container = styled.div`
  display: flex;
  position: relative;
  margin-top: 20px;
`;

export const CalendarContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

export const Col = styled.div<ColProps>`
  width: 100%;
  &:not(&:last-of-type) {
    border-right: ${({ theme }) => `1px solid ${theme.palette.bg500}`};
  }

  ${({ columnWidth }) =>
    columnWidth &&
    css`
      flex: 0 0
        ${typeof columnWidth === 'number' ? `${columnWidth}px` : columnWidth};
    `}
`;

export const ColBlock = styled(BlockBase)<ColBlockProps>`
  position: relative;
  &:not(&:first-of-type) {
    border-top: 1px solid ${({ theme }) => theme.palette.bg500};
  }
  border-style: ${({ isHalf }) => (isHalf ? 'dashed' : 'solid')};
  z-index: ${({ isExistSchedule }) => (isExistSchedule ? 11 : 0)};
`;
